// src/App.js
import React, { useEffect } from "react";
import "./App.css";
import { Route, Routes } from "react-router-dom";
import "@fontsource/poppins";
import AdminNavigation from "navigation/adminNavigation";
import { AdminModal, FullScreenModal, ToastWrapper } from "components/atoms";
import { useSelector } from "react-redux";

// const API = process.env.REACT_APP_API;

const App = () => {
  const { settings } = useSelector((state) => state.settings);

  useEffect(() => {
    if (settings?.app_name) {
      document.title = `${settings.app_name} - Admin`;
    }
  }, [settings?.app_name]);
  return (
    <>
      <ToastWrapper />
      <AdminModal />
      <FullScreenModal />
      <Routes>
        {/* Dialer route */}
        <Route path="/*" element={<AdminNavigation />} />
      </Routes>
    </>
  );
};

export default App;
